function formatWithTimezoneOffset(dateString) {
  const timezoneOffset = new Date().getTimezoneOffset();

  // Convert the offset to hours and ensure it's in ISO 8601 format (+hh:mm or -hh:mm)
  const offsetHours = Math.floor(Math.abs(timezoneOffset) / 60);
  const offsetMinutes = Math.abs(timezoneOffset) % 60;
  const offsetSign = timezoneOffset > 0 ? "-" : "+";
  const offsetString = `${offsetSign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`;

  return `${dateString}T00:00:00.000${offsetString}`;
}

function getMonthName(month) {
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  return months[month];
}

function getDayOfWeek(date) {
  const daysOfTheWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  return daysOfTheWeek[date.getUTCDay()];
}

function getPaddedMonthOrDay(monthOrDay) {
  let mod = monthOrDay.toString();

  if (mod.length > 1) {
    return mod;
  }

  return mod.padStart(2, "0");
}

export default class LocalDate {
  constructor(dateString) {
    this.date = dateString ? new Date(formatWithTimezoneOffset(dateString)) : new Date();
    this.date.setHours(0, 0, 0, 0);
    this.year = this.date.getUTCFullYear();
    this.month = this.date.getUTCMonth();
    this.day = this.date.getUTCDate();
  }

  monthName() {
    return getMonthName(this.month);
  }

  monthYear() {
    return this.monthName() + ' ' + this.year;
  }

  paddedMonth() {
    return getPaddedMonthOrDay(this.month);
  }

  firstDay() {
    return new Date(this.year, this.month, 1);
  }

  firstDayPosition() {
    return this.firstDay().getUTCDay();
  }

  lastDay() {
    return new Date(this.year, this.month, 0);
  }

  lastDayNumber() {
    return this.lastDay().getUTCDate();
  }

  lastDayPosition() {
    return this.lastDay().getUTCDay();
  }

  paddedDay() {
    return getPaddedMonthOrDay(this.day);
  }

  formattedDate() {
    return formattedDate(this.date);
  }

  nextMonthDateString() {
    let temp = this.nextMonthDate();

    let year = temp.getUTCFullYear();
    let month = getPaddedMonthOrDay(temp.getUTCMonth() + 1);

    return `${year}-${month}-01`;
  }

  nextMonthDate() {
    let temp = this.date;
    return new Date(temp.getUTCFullYear(), temp.getUTCMonth() + 1, 1);
  }

  nextYear() {
    let temp = new Date(this.date);
    temp.setFullYear(this.date.getUTCFullYear() + 1);

    return new Date(temp.getUTCFullYear(), temp.getUTCMonth() + 1, 0);
  }
}

export function getOffsetMonth(date, offset = 0) {
  let temp = new Date(date);
  temp.setMonth(date.getUTCMonth() + offset);

  return temp;
}

export function getOffsetDay(date, offset = 0) {
  let temp = new Date(date);
  temp.setDate(date.getUTCDate() + offset);

  return temp;
}

export function formattedDateString(date) {
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();

  return `${year}-${getPaddedMonthOrDay(month)}-${getPaddedMonthOrDay(day)}`;
}

export function formattedDate(date) {
  const year = date.getUTCFullYear();
  const month = getMonthName(date.getUTCMonth());
  const day = date.getUTCDate();

  return `${month} ${day}, ${year}`;
}

export function formatPromoDate(date) {
  const dayOfWeek = getDayOfWeek(date);
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();

  return `${dayOfWeek}, ${month}/${day}`;
}

export function getCurrentDayPromos(mappedCalendarDays, value) {
  if (mappedCalendarDays) {
    return mappedCalendarDays.find(day => day.date === formattedDateString(value));
  }

  return false;
}

export function formatShortWeekday(locale, date) {
  const customWeekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const dayOfWeek = (date.getUTCDay() + 6) % 7;

  return customWeekdays[dayOfWeek];
}

export function decodeHtmlEntity(htmlEntity) {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = htmlEntity;

  return textarea.value;
}

export function formatTime(timeString) {
  let [hours, minutes] = timeString.split(':');

  hours = parseInt(hours, 10);

  const meridian = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12;

  if (minutes === '00') {
    return hours + decodeHtmlEntity('&nbsp;') + meridian;
  }

  return hours + ':' + minutes + decodeHtmlEntity('&nbsp;') + meridian;
}

export function parseId(idString) {
  if (idString) {
    const idInt = parseInt(idString);

    if (idInt === 0) {
      return null;
    }

    return idInt;
  }

  return null;
}
